jQuery(document).ready(function ($) {
    $('.guest-testimonials__carousel').each(function () {
        const $carousel = $(this);

        new Swiper(`#${$carousel.attr('id')}`, {
            slidesPerView: 1,
            slidesPerGroup: 1,

            loop: $carousel.find('.swiper-slide').length > 1,

            grabCursor: true,

            navigation: {
                prevEl: $carousel.find('.guest-testimonials__carousel--prev')[0],
                nextEl: $carousel.find('.guest-testimonials__carousel--next')[0]
            }
        });
    });
});
